var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "14px",
    viewBox: "0 0 11 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placeholder (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.517647 0 0 0 0 0.517647 0 0 0 0 0.517647 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "High-Fidelity",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NOU_Seleccionar_Pin_Mapa_bicing",
    transform: "translate(-37.000000, -670.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "placeholder-(1)",
    transform: "translate(20.000000, 578.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.567856,0.00224 L5.567856,0 C5.552848,0 5.538176,0.000896 5.523504,0.000896 C5.508832,0.000896 5.49416,0 5.479152,0 L5.479152,0.00224 C2.480128,0.049952 0.06328,2.494128 0.06328,5.504576 C0.06328,9.561328 4.826192,13.411888 5.523504,13.959008 C6.220928,13.412 10.983728,9.561216 10.983728,5.504576 C10.983728,2.494128 8.566992,0.049952 5.567856,0.00224 Z M5.567856,7.872368 C3.998624,7.872368 2.726752,6.60072 2.726752,5.031712 C2.726752,3.462256 3.998624,2.190384 5.567856,2.190384 C7.137088,2.190384 8.409072,3.462256 8.409072,5.031712 C8.409072,6.60072 7.137088,7.872368 5.567856,7.872368 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemPlace);
export default __webpack_public_path__ + "static/media/system-place.a274cdf6.svg";
export { ForwardRef as ReactComponent };